<template>
  <div class="modal" v-if="active && headline && text">
    <div class="mb" v-html="headline"></div>
    <div class="mb" v-html="text"></div>
    <div
      class="btn"
      @click="
        active = false;
        headline = null;
        text = null;
        $router.go();
      "
    >
      OK
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      headline: null,
      text: null,
    };
  },
  mounted() {
    this.$root.$on("modal", this.showModal);
  },
  methods: {
    showModal(data) {
      this.headline = data.title;
      this.text = data.text;
      this.active = true;
      // console.log(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 500px;
  padding: var(--lh);
  transform: translate(-50%, -50%);
  background: white;
  color: black;
  z-index: 999;
  a {
    color: black;
    border-color: black;
  }
  .btn {
    cursor: pointer;
  }
}
</style>
